"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.searchWithPlexUrlParams = exports.extractPlexUrlParams = exports.encode = exports.decode = exports.PLEX_SELECTED_ITEM_PARAM = void 0;
exports.PLEX_SELECTED_ITEM_PARAM = 'query';
function decode(param) {
    if (param === '') {
        return {};
    }
    return JSON.parse(Buffer.from(decodeURIComponent(param), 'base64').toString('binary'));
}
exports.decode = decode;
function encode(args) {
    return encodeURIComponent(Buffer.from(JSON.stringify(args), 'binary').toString('base64'));
}
exports.encode = encode;
function extractPlexUrlParams({ search }) {
    const searchParams = new URLSearchParams(search);
    const urlParam = searchParams.get(exports.PLEX_SELECTED_ITEM_PARAM);
    if (urlParam == null) {
        return null;
    }
    else {
        try {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const _a = decode(urlParam), { v } = _a, urlParams = __rest(_a, ["v"]);
            return urlParams;
        }
        catch (err) {
            if (err instanceof SyntaxError) {
                return { invalid: true };
            }
            else {
                throw err;
            }
        }
    }
}
exports.extractPlexUrlParams = extractPlexUrlParams;
function searchWithPlexUrlParams({ search }, urlParams) {
    const searchParams = new URLSearchParams(search);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const newParams = Object.assign(Object.assign({}, extractPlexUrlParams({ search })), urlParams);
    const hasNonNullFields = Object.values(newParams).filter((field) => field != null).length > 0;
    if (hasNonNullFields) {
        const versionedArgs = Object.assign(Object.assign({}, newParams), { v: '1' });
        searchParams.set(exports.PLEX_SELECTED_ITEM_PARAM, encode(versionedArgs));
    }
    else {
        searchParams.delete(exports.PLEX_SELECTED_ITEM_PARAM);
    }
    return searchParams.toString();
}
exports.searchWithPlexUrlParams = searchWithPlexUrlParams;
//# sourceMappingURL=plexUrlParams.js.map